import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CAMPAIGN, COPYRIGHT_LINE } from "@/lib/campaign";
import { SectionBg } from "@/components/SectionBg";

const NEXT_STEPS = [
  "Watch your inbox for the event confirmation from Chaunci Witherspoon, MBA and Kinsfolk Mortgage.",
  "Add the sender to your contacts so you do not miss the live-session update.",
  "Reminders are sent only according to the consent choices you made at registration.",
];

export default function ThankYou() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative overflow-hidden min-h-screen flex items-center px-5 md:px-10 py-20" data-testid="thank-you-page">
      <SectionBg img="bg-home-6.jpg" strength={0.92} />
      <div className="relative z-10 max-w-2xl mx-auto text-left w-full">
        <div className="w-12 h-12 rounded-[6px] bg-[var(--accent)] text-[var(--background-deep)] flex items-center justify-center text-2xl font-semibold mb-8">
          ✓
        </div>
        <p className="font-mono text-xs tracking-[0.28em] text-[var(--accent)] mb-4">
          REGISTRATION CONFIRMED · BENEFIT TO KEYS
        </p>
        <h1 className="font-display font-semibold text-4xl sm:text-5xl leading-tight text-white mb-6">
          You are registered.
        </h1>
        <p className="text-base md:text-lg leading-relaxed text-[rgba(255,255,255,0.8)] mb-8">
          Watch for your confirmation details from Chaunci Witherspoon, MBA and Kinsfolk Mortgage. Add the
          sender to your contacts so you do not miss the live-session update.
        </p>

        <div className="glass-panel rounded-[6px] p-6 md:p-8 mb-8">
          <p className="font-mono text-[10px] tracking-[0.24em] text-[var(--muted)] mb-3">YOUR SESSION</p>
          <p className="font-display text-xl md:text-2xl text-white mb-2">
            The Florida VA Homebuying Workshop
          </p>
          <p className="font-mono text-[11px] tracking-[0.08em] text-[var(--muted)]">
            {CAMPAIGN.webinarDate} · {CAMPAIGN.webinarTime} · {CAMPAIGN.webinarTimezone}
          </p>
        </div>

        <p className="font-mono text-[10px] tracking-[0.24em] text-[var(--accent)] mb-4">WHAT HAPPENS NEXT</p>
        <ul className="space-y-3 mb-10">
          {NEXT_STEPS.map((s, i) => (
            <li key={i} className="flex items-start gap-3 text-sm md:text-base text-[rgba(255,255,255,0.78)]">
              <span aria-hidden="true" className="font-mono text-[var(--accent)]">→</span>
              {s}
            </li>
          ))}
        </ul>

        <Link
          to="/"
          data-testid="thank-you-home-link"
          className="glint inline-block border border-[var(--accent)] text-[var(--accent)] font-semibold text-sm tracking-[0.12em] px-8 py-4 rounded-[4px] hover:bg-[var(--accent)] hover:text-[var(--background-deep)] transition-colors duration-250"
        >
          BACK TO THE WORKSHOP PAGE
        </Link>

        <p className="font-mono text-[10px] tracking-[0.08em] text-[rgba(255,255,255,0.4)] mt-14 border-t border-[var(--line)] pt-6">
          {COPYRIGHT_LINE}
        </p>
      </div>
    </div>
  );
}
